<template>
  <div class="session-list" v-if="detail">
    <!-- 头部 -->
    <div class="session-header">
      <div class="session-header-main">
        <div class="session-header-company">
          <div class="logo">
            <img :src="detail.avatarUrl" alt />
          </div>
          <div class="session-header-company-pra">
            <p class="name">{{ detail.nameCn }}</p>
            <div class="label">
              <span>{{ detail.financingTypeName }}</span>
              <span class="separated"></span>
              <span>{{ detail.scaleTypeName }}</span>
              <img
                src="../../assets/images/huo.png"
                alt=""
                :title="title"
                class="fire"
                v-for="(item, index) in browseNumData"
                :key="index"
              />
            </div>
            <div class="time" v-if="detail.effectiveEndList">
              <span>专场时间：{{ detail.effectiveEndList[0] }}</span>
              <span>简历截止：{{ detail.expirationDate }}</span>
            </div>
          </div>
        </div>
        <!-- 分类 -->
        <el-tabs v-model="tabsIndex" class="session-header-tabs">
          <el-tab-pane
            :label="`职位招聘（${pagination.totalRow}个）`"
            name="0"
          ></el-tab-pane>
          <el-tab-pane label="公司介绍" name="1"></el-tab-pane>
        </el-tabs>
      </div>
    </div>
    
    <!-- 招聘职位 -->
    <div class="session-main" v-if="tabsIndex == 0">
      <div class="position" v-for="(item, index) in position" :key="index">
        <router-link
          :to="`/job/detail?id=${item.id}`"
          target="_blank"
          class="position-left"
        >
          <p>{{ item.name }}</p>
          <p class="position-salary">{{ item.salaryRangeName }}</p>
          <div class="position-detail">
            <span>{{ item.address }}</span>
            <span class="separated"></span>
            <span>经验{{ item.workExperienceName }}</span>
            <span class="separated"></span>
            <span>{{ item.qualificationsName }}</span>
            <span class="separated"></span>
            <span>招聘{{ item.numbers }}人</span>
            <span v-if="item.deptName" class="separated"></span>
            <span>{{ item.deptName }}</span>
          </div>
        </router-link>

        <div class="position-right">
          <p v-if="item.favorite" @click="favoriteDelete(item.id, index)">
            <span class="fonticon">&#xe623;</span>
            <span>已收藏</span>
          </p>

          <p v-else @click="favoriteAdd(item.id, index)">
            <span class="fonticon">&#xe62f;</span>
            <span>收藏</span>
          </p>

          <p class="position-right" style="margin-left:20px">
            <like-browsing
              @thumbsUpFn="thumbsUpFn(item.id)"
              :browseNum="item.browseNum"
              :likeNum="item.likeNum"
              @unThumbsUpFn="unThumbsUpFn(item.id)"
              :isUp="item.isLike"
            >
            </like-browsing>
          </p>

          <router-link
            :to="`/job/detail?id=${item.id}`"
            target="_blank"
            class="position-right-look"
            >查看职位</router-link
          >
        </div>
      </div>
      <!-- 页码 -->
      <pagination
        :total="pagination.totalRow"
        v-model="pageIndex"
        class="pagination"
      ></pagination>
    </div>
    <!-- 公司介绍 -->
    <div class="session-main" v-else>
      <div class="introduce" v-html="detail.description"></div>
    </div>
  </div>
</template>

<script>
import likeBrowsing from "../../components/likeBrowsing/index.vue";
import { mapActions } from "vuex";
export default {
  components: {
    likeBrowsing
  },
  name: "session",
  data() {
    return {
      title: "",
      companyId: "",
      tabsIndex: "0",
      pageIndex: 1,
      pageSize: 10,
      position: [],
      pagination: {},
      detail: {},
      browseNumData: []
    };
  },
  async created() {
    this.companyId = this.$route.query.id;
    this.getDetail();
    this.getList();
  },
  watch: {
    pageIndex() {
      this.getList();
    }
  },
  methods: {
    ...mapActions([
      "getCompanyDetail",
      "getSessionPosition",
      "addFavorite",
      "deleteFavorite",
      "giveThumbsUp",
      "unGiveThumbsUp"
    ]),

    // 点赞
    async thumbsUpFn(id) {
      let params = { id: id };
      const data = await this.giveThumbsUp(params);
      if (data.code !== 200) {
        return this.$message.error(data.message);
      }
      //  await this.getJobsList();
    },

    // 取消点赞
    async unThumbsUpFn(id) {
      let params = { id: id };
      const data = await this.unGiveThumbsUp(params);
      if (data.code !== 200) {
        return this.$message.error(data.message);
      }
      //  await this.getJobsList();
    },

    // 获取公司详情
    async getDetail() {
      const res = await this.getCompanyDetail(this.companyId);
      if (res) {
        this.detail = res;
        let browse = res.browseNum;
        if (browse <= 20) {
          this.browseNumData.length = 1;
          this.title = "一般";
        } else if (browse > 20 && browse <= 60) {
          this.title = "适中";
          this.browseNumData.length = 2;
        } else {
          this.title = "火爆";
          this.browseNumData.length = 3;
        }
      }
    },
    // 获取招聘职位列表
    async getList() {
      const res = await this.getSessionPosition({
        debug: true,
        companyId: this.companyId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      });
      if (res) {
        this.position = res.data;
        this.pagination = res.pagination;
      }
    },
    // 添加收藏职位
    async favoriteAdd(id, index) {
      const res = await this.addFavorite(id);
      if (res && res.code == 200) {
        this.position[index]["favorite"] = !this.position[index]["favorite"];
        this.$message({
          message: "收藏成功",
          type: "success"
        });
      } else {
        this.$message({
          message: res.message,
          type: "warning"
        });
      }
    },
    // 删除收藏职位
    async favoriteDelete(id, index) {
      const res = await this.deleteFavorite(id);
      if (res) {
        this.position[index]["favorite"] = !this.position[index]["favorite"];
        this.$message({
          message: "取消收藏成功",
          type: "success"
        });
      }
    }
  }
};
</script>

<style lang="less">
.fire {
  width: 25px;
  height: 25px;
  margin-left: 10px;
}
.session-list {
  .session-header {
    width: 100%;
    height: 200px;
    background: #049cfd;
    box-sizing: border-box;
    padding-top: 40px;
    &-main {
      width: 1200px;
      margin: auto;
    }
    &-company {
      display: flex;
      align-items: center;
      .logo {
        width: 84px;
        height: 84px;
        background: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          display: block;
          width: 56px;
        }
      }
      &-pra {
        height: 84px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-left: 20px;
        .name {
          font-size: 18px;
          color: #fff;
        }
        .label {
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #fff;
          .separated {
            margin: 0 20px;
            display: block;
            width: 1px;
            height: 10px;
            background: #fff;
            opacity: 0.3;
          }
        }
        .time {
          span {
            display: inline-block;
            // width: 200px;
            height: 30px;
            line-height: 30px;
            border-radius: 15px;
            text-align: center;
            background: #0583d4;
            font-size: 14px;
            color: #fff;
            margin-right: 20px;
            padding: 0 20px;
          }
        }
      }
    }
    &-tabs {
      display: flex;
      align-items: center;
      font-size: 18px;
      color: #fff;
      margin-top: 30px;
      p {
        margin-right: 40px;
        padding-bottom: 8px;
        cursor: pointer;
      }
      .el-tabs__item {
        color: #fff;
        padding: 0;
        margin-right: 30px;
      }
      .el-tabs__nav-wrap::after {
        content: none;
      }
      .el-tabs__item.is-active {
        color: #fff;
        border-bottom: 2px solid #fff;
      }
      .el-tabs__active-bar {
        background: #fff;
      }
    }
  }
  .session-main {
    width: 1200px;
    margin: 20px auto 0;
    .introduce {
      background: #fff;
      padding: 30px 20px;
      font-size: 16px;
      line-height: 30px;
      margin-bottom: 20px;
    }
    .position {
      height: 115px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px;
      background: #fff;
      margin-bottom: 10px;
      &-left {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        font-size: 18px;
        color: #333;
      }
      &-salary {
        color: #ff5555;
      }
      &-detail {
        font-size: 14px;
        color: #666;
        display: flex;
        align-items: center;
        .separated {
          display: block;
          width: 1px;
          height: 8px;
          background: #ccc;
          margin: 0 10px;
        }
      }
      &-right {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #049cfd;
        p {
          cursor: pointer;
        }
        .fonticon {
          font-size: 16px;
          margin-right: 6px;
        }
        &-look {
          display: block;
          width: 120px;
          height: 40px;
          background: #049cfd;
          color: #fff;
          text-align: center;
          line-height: 40px;
          margin-left: 20px;
        }
      }
    }
  }
}
</style>
